import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dreamy%20soft%20pastel%20illustration%20style%20background%20with%20floating%20cherry%20blossom%20petals%20and%20subtle%20manga%20panel%20lines%20in%20the%20distance%20gentle%20gradient%20from%20warm%20peach%20to%20soft%20pink%20minimalist%20abstract%20composition%20whimsical%20and%20romantic%20atmosphere%20no%20text%20no%20characters%20clean%20background&width=1920&height=700&seq=hero-bg-manga-01&orientation=landscape"
          alt="亲亲漫画网背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold font-heading text-white mb-4 leading-tight">
          下拉式完整版
          <span className="block text-accent-300">免费漫画阅读</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          海量<strong>无删减韩国漫画</strong>资源，<strong>下拉观看</strong>流畅不卡顿，
          甜蜜剧情与细腻画风一网打尽，尽在<strong>亲亲漫画网</strong>
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
          <div className="relative w-full sm:w-96">
            <input
              type="text"
              placeholder="搜索你喜欢的漫画..."
              className="w-full pl-11 pr-4 py-3.5 text-sm rounded-full bg-white/95 border-0 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
          </div>
          <Link
            to="/"
            className="px-8 py-3.5 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即阅读
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">12,000+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">漫画资源</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">500万+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">月活跃读者</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">99.9%</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">阅读流畅度</div>
          </div>
        </div>
      </div>
    </section>
  );
}